export default {
  state: {
    setItem: {},
    dimensionImage: ""
  },

  mutations: {
    setSetItem(state, setItem) {
      state.setItem = setItem;
    },

    setDimensionImage(state, image) {
      state.dimensionImage = image;
    },
  },
};
